import styled from "styled-components";

const IconStyles = styled.svg`
  display: inline-block;
  &.icon-eight-px {
    width: 8px;
    height: 8px;
  }
   &.icon-ten-px {
    width: 10px;
    height: 10px;
  }
  &.icon-twelve-px {
    width: 12px;
    height: 12px;
  }
  &.icon-thirteen-px {
    width: 13px;
    height: 13px;
  }
  &.icon-sixteen-px {
    width: 16px;
    height: 16px;
  }
  &.icon-eighteen-px {
    width: 18px;
    height: 18px;
  }
  &.icon-twenty-px {
    width: 20px;
    height: 20px;
  }
  &.icon-twenty-four-px {
    width: 24px;
    height: 24px;
  }
  &.icon-twenty-eight-px {
    width: 28px;
    height: 28px;
  }
  &.icon-thirty-two-px {
    width: 33px;
    height: 33px;
  }
  &.icon-fourty-px {
    width: 40px;
    height: 40px;
  }
  &.icon-fourty-eight-px {
    width: 48px;
    height: 48px;
  }
  &.icon-sixty-px {
    width: 60px;
    height: 60px;
  }
  &.icon-sixty-four-px {
    width: 64px;
    height: 64px;
  }
  &.icon-thirtytwo-fifteen-px {
    width: 32px;
    height: 15px;
  }
  &.icon-forty-twentytwo-px {
    width: 40px;
    height: 22px;
  }
  &.logo {
    width: 63px;
    height: 41px; 
  }
}
`;
export default IconStyles;
